import { render, staticRenderFns } from "./F3.vue?vue&type=template&id=127caa62&scoped=true"
import script from "./F3.vue?vue&type=script&lang=js"
export * from "./F3.vue?vue&type=script&lang=js"
import style0 from "./F3.vue?vue&type=style&index=0&id=127caa62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127caa62",
  null
  
)

export default component.exports